import { render } from "./MainView.vue?vue&type=template&id=5870855a&scoped=true"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"

import "@/styles/views/main.css?vue&type=style&index=0&id=5870855a&scoped=true&lang=css"
import "./MainView.vue?vue&type=style&index=1&id=5870855a&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"
import "./MainView.vue?vue&type=style&index=3&id=5870855a&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5870855a"]])

export default __exports__